import type { ClientRelatedCandidateResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { getRelatedPropertyTitle } from "web_myplann/Portfolio/Helpers/getRelatedPropertyTitle";
import { relatedPortfolioLabel } from "web_myplann/Portfolio/Helpers/relatedPortfolioLabel";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";

export const relatedCandidateTitle = (
	candidate: ClientRelatedCandidateResponseDTO,
	t: TranslateFunction,
): string => {
	if (candidate.type) {
		return getRelatedPropertyTitle({ ...candidate, type: candidate.type }, t);
	}

	if (candidate.domain) {
		return relatedPortfolioLabel({ ...candidate, domain: candidate.domain }, t);
	}

	return candidate.name ?? "";
};

export const relatedCandidateSubtitle = (
	candidate: ClientRelatedCandidateResponseDTO,
): string | undefined => {
	if (candidate.type) {
		return (
			[candidate.location, candidate.locationMunicipality]
				.filter(Boolean)
				.join(", ") || undefined
		);
	}

	return candidate.contractNumber ?? undefined;
};
